import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import SocialIcons from './components/SocialIcons';
import BandStory from './components/BandStory';
import Music from './components/Music';
import Shows from './components/Shows';
import Tienda from './components/Tienda';
import Gallery from './components/Gallery';
import './App.scss';

function App() {
  const [currentSection, setCurrentSection] = useState('home');
  const [showPopup, setShowPopup] = useState(true);
  const [daysLeft, setDaysLeft] = useState(0);

  useEffect(() => {
    const calculateDaysLeft = () => {
      const releaseDate = new Date('2025-03-27');
      const today = new Date();
      const diffTime = releaseDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setDaysLeft(diffDays);
    };

    calculateDaysLeft();
    // Update every day
    const interval = setInterval(calculateDaysLeft, 86400000);
    return () => clearInterval(interval);
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target.className === 'popup-overlay') {
      setShowPopup(false);
    }
  };

  const handleCtaClick = (e) => {
    e.preventDefault();
    window.open('https://distrokid.com/hyperfollow/vuelodespierto/pociones-en-vivo', '_blank');
    setShowPopup(false);
  };

  const sectionVariants = {
    hidden: { 
      opacity: 0,
      y: 50,
    },
    visible: { 
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    },
    exit: { 
      opacity: 0,
      y: -50,
      transition: {
        duration: 0.6,
        ease: "easeIn"
      }
    }
  };

  return (
    <div className={`app background-${currentSection}`}>
      <div className="background-overlay"></div>
      <div className="background-image"></div>
      
      <header>
        <div className="logo">
          <a onClick={() => setCurrentSection('home')} style={{ cursor: 'pointer' }}>
            <motion.img 
              src="/vuelo_despierto_nombre_blanco.png" 
              alt="Name" 
              className="logo-image"
              whileHover={{ scale: 1.2 }}
              transition={{ type: "spring", stiffness: 300 }}
            />
          </a>
        </div>
        <Navbar currentSection={currentSection} setCurrentSection={setCurrentSection} />
      </header>

      <SocialIcons />

      <main className="main-content">
        <AnimatePresence mode="wait">
          {currentSection === 'home' && (
            <motion.section 
              key="home"
              className="section hero"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={sectionVariants}
            >
              {/* Hero content */}
            </motion.section>
          )}

          {currentSection === 'tour' && (
            <motion.section 
              key="tour"
              className="section"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={sectionVariants}
            >
              <Shows />
            </motion.section>
          )}

          {currentSection === 'tienda' && (
            <motion.section 
              key="tienda"
              className="section"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={sectionVariants}
            >
              <Tienda />
            </motion.section>
          )}

          {currentSection === 'fotos' && (
            <section id="fotos" className="section">
              <Gallery />
            </section>
          )}
        </AnimatePresence>
      </main>

      <div className="footer-mark">
        <p>© 2025 Vuelo Despierto</p>
        <p>Us <b>vuelodespierto@gmail.com</b></p>
        <p>MGMT <b>mobe@gmail.com</b></p>
      </div>

      {showPopup && (
        <div className="popup-overlay" onClick={handleOverlayClick}>
          <div className="release-popup">
            <div className="release-popup__title">Nuevo Single</div>
            <div className="release-popup__date">
              <div className="countdown">
                <span className="prefix">En</span>
                <span className="number">{daysLeft}</span>
                <span className="label">días</span>
              </div>
            </div>
            <div className="release-popup__image-container">
              <img src="/spotify_presave_picture.jpg" alt="Single Cover" className="release-popup__image" />
            </div>
            <a href="#" onClick={handleCtaClick} className="release-popup__cta">
              SUSCRIBITE
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default App; 